import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { ModeProvider } from "@/providers/ModeProvider";
import { IntegrationProvider } from "@/providers/IntegrationProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/providers/AuthProvider";
import { configureAuth } from "@/lib/auth-fetch";
import { setApiUrl } from "@/lib/api-config";
import App from "@/App";
import "../globals.css";

interface AppContainerProps {
  settings?: {
    apiUrl?: string;
    clientId?: string;
    defaultUrl?: string;
    identityUrl?: string;
    redirectUri?: string;
    scope?: string;
    workspaceUrl?: string;
  };
  bypassPermissions?: boolean;
}

export default function AppContainer({ settings, bypassPermissions }: AppContainerProps = {}): React.ReactElement {
  const { getAccessToken, instanceId } = useAuth();

  console.log('[AppContainer] settings:', settings);
  console.log('[AppContainer] settings.apiUrl:', settings?.apiUrl);

  // Set apiUrl synchronously before render to ensure it's available for API calls
  if (settings?.apiUrl) {
    console.log('[AppContainer] Setting API URL to:', settings.apiUrl);
    setApiUrl(settings.apiUrl);
  } else {
    console.log('[AppContainer] No apiUrl in settings, not calling setApiUrl');
  }

  // Configure auth synchronously before render to ensure it's available for API calls
  // This prevents race conditions where API calls (like import jobs) are made before auth is configured
  configureAuth({ getAccessToken, instanceId });

    return (
      <QueryProvider>
        <TooltipProvider>
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
            <ModeProvider>
              <IntegrationProvider>
                <Toaster richColors duration={5000} closeButton />
                <App bypassPermissions={bypassPermissions} />
              </IntegrationProvider>
            </ModeProvider>
          </ThemeProvider>
        </TooltipProvider>
      </QueryProvider>
    );
}
